import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, FormCheck, Col, InputGroup, Button, ButtonGroup} from "react-bootstrap";
import {config} from "../../components/Constants";

class ClientsUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: true,
            isLoggedIn: false,
            redirect: null,
            client: false
        };
        this.handleReturn = this.handleReturn.bind(this);
    }

    componentDidMount() {
    }

    handleReturn(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            redirect: '/clients'
        });
        return false;
    }

    render() {
        const {error, isLoaded, isLoggedIn, redirect, client} = this.state;
        const that = this;
        if (!isLoaded || client === false) {
            return (
                <LoadingSpin/>
            );
        } else if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (client === null) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={'Nie znaleziono klienta o ID: '+this.props.match.params.id} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', client: {}});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', client: {}});}}/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', error: null});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', error: null});}}/>
            );
        } else {
            return (
                <React.Fragment>
                    <header className="clients-header">
                        <h1>Użytkownicy obiektu: {client.nazwa}</h1>
                    </header>
                    <div className="section-div">
                        <h2></h2>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ClientsUsers;
